import {_getDocumentNodeIds} from './utils'

/**
 * Gets the first block node positioned before supplied node, or
 * the last block node in article if no reference node is supplied
 *
 * @param {EditorSession} editorSession
 * @param {Object} [refNode=null] - Node to use as reference
 *
 * @returns {Object|null}
 */
function getPreviousBlockNode(editorSession, refNode = null) {
    const nodeIds = _getDocumentNodeIds(editorSession, 'body')
    const index = refNode ? nodeIds.indexOf(refNode.id) : nodeIds.length - 1

    for(let n = index; n >= 0; n--) {
        const node = editorSession.getDocument().get(nodeIds[n])

        if (node.ignorePosition !== true) {
            return node
        }
    }

    return null
}

export {getPreviousBlockNode}
